import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f2d616c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "lp-card reco"
}
const _hoisted_2 = { class: "reco__thumb" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "reco__info" }

import { computed } from 'vue';
import HcIcon from '@/modern/components/ui/HcIcon.vue';
import { useCourseI18n } from '../course';


export default /*#__PURE__*/_defineComponent({
  props: {
    machines: null
  },
  setup(__props: any) {

const props = __props as {
  machines: any[]
}



const { t, lang, tc } = useCourseI18n();

const OS_NAMES: Record<string, string> = { linux: 'Linux', windows: 'Windows', osx: 'macOS', android: 'Android', androiud: 'Android' };

const items = computed(() => props.machines.slice(0, 6));

const meta = (machine: any) => {
  const parts: string[] = [];
  const level = String(machine.dificulty || '').toLowerCase();
  if (['easy', 'medium', 'hard', 'insane'].includes(level)) parts.push(t(`${lang.value}.common.${level}`));
  const os = OS_NAMES[String(machine.os_name || '').toLowerCase()];
  if (os) parts.push(os);
  if (machine.total_flags) parts.push(`${machine.total_flags} flags`);
  return parts.join(' · ');
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(items).length)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("h3", null, _toDisplayString(_unref(tc)('recommended_title')), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(t)(`${_unref(lang)}.machine.this_list_machines_based_this_lesson`)), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (machine) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: machine.id,
            to: `/training/training-machines/${machine.id}`,
            class: "reco__item"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, [
                (machine.photo_path)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: machine.photo_path,
                      alt: machine.name
                    }, null, 8, _hoisted_3))
                  : (_openBlock(), _createBlock(HcIcon, {
                      key: 1,
                      name: "display",
                      size: 20
                    }))
              ]),
              _createElementVNode("span", _hoisted_4, [
                _createElementVNode("strong", null, _toDisplayString(machine.name), 1),
                _createElementVNode("span", null, _toDisplayString(meta(machine)), 1)
              ]),
              _createElementVNode("span", {
                class: _normalizeClass(["reco__pct", { 'reco__pct--done': Number(machine.percentage) >= 100 }])
              }, _toDisplayString(Math.round(Number(machine.percentage) || 0)) + "%", 3)
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})